/**
 * Soft iMessage-like tones for Tent chat (Web Audio — no asset files).
 * Browsers require a user gesture before audio; unlock on first interaction.
 */

let audioCtx = null;

const getContext = () => {
    if (typeof window === 'undefined') return null;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    if (!audioCtx || audioCtx.state === 'closed') {
        audioCtx = new Ctx();
    }
    return audioCtx;
};

export const unlockTentChatSounds = () => {
    const ctx = getContext();
    if (!ctx) return;
    if (ctx.state === 'suspended') {
        ctx.resume().catch(() => {});
    }
};

const tone = (ctx, { frequency, start, duration, type = 'sine', gain = 0.08, slideTo }) => {
    const osc = ctx.createOscillator();
    const amp = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, start);
    if (slideTo != null) {
        osc.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), start + duration);
    }
    amp.gain.setValueAtTime(0.0001, start);
    amp.gain.exponentialRampToValueAtTime(gain, start + 0.012);
    amp.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    osc.connect(amp);
    amp.connect(ctx.destination);
    osc.start(start);
    osc.stop(start + duration + 0.02);
};

/** Short rising send “whoosh/pop” — similar feel to iMessage send. */
export const playTentSendSound = () => {
    const ctx = getContext();
    if (!ctx) return;
    const t = ctx.currentTime;
    if (ctx.state === 'suspended') {
        ctx.resume().catch(() => {});
    }
    tone(ctx, { frequency: 820, start: t, duration: 0.07, type: 'sine', gain: 0.05, slideTo: 1180 });
    tone(ctx, { frequency: 1180, start: t + 0.04, duration: 0.09, type: 'triangle', gain: 0.035, slideTo: 900 });
};

/** Soft two-note receive — similar feel to iMessage receive. */
export const playTentReceiveSound = () => {
    const ctx = getContext();
    if (!ctx) return;
    const t = ctx.currentTime;
    if (ctx.state === 'suspended') {
        ctx.resume().catch(() => {});
    }
    tone(ctx, { frequency: 520, start: t, duration: 0.11, type: 'sine', gain: 0.06 });
    tone(ctx, { frequency: 690, start: t + 0.09, duration: 0.14, type: 'sine', gain: 0.045 });
};
